import { type AnyAction } from 'redux';
import { SET_IS_POST_IN_PREVIEW } from './set-is-post-in-preview-action';

const isPostInPreview = (state: boolean = false, { type, payload }: AnyAction): boolean => {
  switch (type) {
    case SET_IS_POST_IN_PREVIEW:
      return payload;
    default:
      return state;
  }
};

export default isPostInPreview;
